module.exports = __webpack_public_path__ + "media/images/sales/early/eyecatch-point-02-a06b9e92183c346d5fd965ac56314574.jpg";